import { Link } from 'react-router-dom';
import { Loading } from '../loading';
import { useAgents } from '../../state';

const promptFor = (agent) => agent.plan?.params?.master || 'Untitled agent';

export const ListAgents = () => {
  const { agents, loading } = useAgents();

  if (loading) {
    return <Loading>Loading agents...</Loading>;
  }

  if (!agents.length) {
    return <div>No agents found.</div>;
  }

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
      {agents.map((agent) => (
        <Link
          key={agent.id}
          to={`/agents/run/${agent.id}`}
          style={{ color: 'black', display: 'block', textDecoration: 'none' }}
        >
          <div style={{ border: '1px solid #d3d3d3', borderRadius: 8, cursor: 'pointer', padding: 12 }}>
            <div style={{ minWidth: 0 }}>
              <div style={{ fontSize: 14 }}>{promptFor(agent)}</div>
              <div style={{ color: '#777', fontSize: 12, marginTop: 5 }}>
                {agent.id} · {new Date(agent.createdAt).toLocaleString()}
              </div>
            </div>
          </div>
        </Link>
      ))}
    </div>
  );
};
